// extracted by mini-css-extract-plugin
export default {"container":"HomeInfoBox_container__1ZYE9","container2":"HomeInfoBox_container2__K3hoc","subscribe":"HomeInfoBox_subscribe__DpDoo","btn":"HomeInfoBox_btn__Xogmf"};